import { makeStyles } from 'tss-react/mui';
import React from 'react';
import ProfileSection from './ProfileSection';
import NavMenu from './NavMenu';
import AppLauncher from 'src/widgets/app-launcher/AppLauncher';
import { IApplication } from '../../routes/Shell';
import { useLocation } from 'react-router-dom';
import { CDN_URL } from '@utils';
import HeaderShell from './HeaderShell';

interface IHeaderProps {
  currentApp: string | undefined;
}

const useStyles = makeStyles()(() => ({
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'flex-end',
    minHeight: '62px',
    maxHeight: '600px',
    margin: '0 20px 0 0',
    textAlign: 'center',
    width: '100%',
  },
}));

const Header: React.FC<
  IHeaderProps & {
    applications: Record<string, IApplication>;
  }
> = ({ currentApp, applications }) => {
  const { classes } = useStyles();
  const location = useLocation();

  return !location.pathname.includes('/privacypolicy') ? (
    <HeaderShell>
      <AppLauncher
        appLauncherUrl={CDN_URL + '/images/app-launcher.svg'}
        applications={applications}
      />
      <NavMenu applications={applications} currentApp={currentApp} />
      <div className={classes.rightContainer}>
        <ProfileSection />
      </div>
    </HeaderShell>
  ) : (
    <HeaderShell></HeaderShell>
  );
};

export default Header;
